import(/* webpackMode: "eager" */ "/app/src/app/deals/page.tsx");
